// extracted by mini-css-extract-plugin
export default {"container":"HJlpQc","inputContainer":"gHoCzt","selectedText":"ZhTfcb","text":"LWWbqK","icon":"vZKfIk"};